import {
FETCH_ACCOUNTS_REQUEST,
FETCH_ACCOUNTS_SUCCESS,
FETCH_ACCOUNTS_FAILURE,
FETCH_ACCOUNTS_COUNT_REQUEST,
FETCH_ACCOUNTS_COUNT_SUCCESS,
FETCH_ACCOUNTS_COUNT_FAILURE
} from "../actions/accountActions";

const initialState = {
    accountList: [],
    totalCount: 0,
    isLoading: false,
     countLoading:false,
    error: null
};

export const accountsReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_ACCOUNTS_REQUEST:
            return { ...state, isLoading: true };

        case FETCH_ACCOUNTS_SUCCESS:
            return { ...state, accountList: action.payload, isLoading: false };

        case FETCH_ACCOUNTS_FAILURE:
            return { ...state, error: action.payload, isLoading: false };

        case FETCH_ACCOUNTS_COUNT_REQUEST:
            return { ...state, countLoading: true };

        case FETCH_ACCOUNTS_COUNT_SUCCESS:
            return { ...state, totalCount: action.payload, countLoading: false };

        case FETCH_ACCOUNTS_COUNT_FAILURE:
            return { ...state, error: action.payload, countLoading: false };

        default:
            return state;
    }
};
